
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"그룹 2050","transform":"translate(-21871 -396)"}},[_c('circle',{attrs:{"data-name":"타원 257","cx":"10","cy":"10","r":"10","transform":"translate(21871 396)","fill":"#727272"}}),_c('g',{attrs:{"data-name":"그룹 2048","fill":"none","stroke":"#fff","stroke-linecap":"round"}},[_c('path',{attrs:{"data-name":"선 743","d":"M21877 402l8 8"}}),_c('path',{attrs:{"data-name":"선 744","d":"M21877 410l8-8"}})])])])
          )
        }
      }
    